// Getters
export const ACT_IS_ERROR = "activation/stateActIsError";
export const ACT_IS_LOADING = "activation/stateActIsLoading";
export const ACT_GET_DATA = "activation/stateActData";
export const ACT_GET_FILTER = "activation/stateActFilter";

//Mutations
export const ACT_MUTATION_FILTER_EMAIL = "activation/stateActFilterEmail";
export const ACT_MUTATION_CLEAR_FILTER = "activation/stateActFilterClear";

// Actions
// export const ACT_ACTION_DATA = 'activation/stateActData';
export const ACT_ACTION_CREATE = "activation/stateActCreate";
export const ACT_ACTION_FILTER = "activation/stateActSearchByFilter";
export const ACT_ACTION_FILTER_EMAIL = "activation/stateActFilterEmail";
export const ACT_ACTION_CLEAR_FILTER = "activation/stateActFilterClear";
export const ACT_ACTION_DELETE_CODE = "activation/deleteCodeById";
export const ACT_ACTION_REFRESH = "activation/stateActRefresh";



// WEBPACK FOOTER //
// ./src/store/types_activation.js